import { FC } from 'react';
import { MarginProps } from 'styled-system';
import { Box, Text } from '@bpba/ui-components';

export const SinProductos: FC<MarginProps> = (props) => {
  return (
    <Box width={'fit-content'} margin={'auto'} marginY={['50px', '100px']} {...props}>
      <Text fontSize={['16px']}>No se encontraron productos</Text>
    </Box>
  );
};
